module.exports = __webpack_public_path__ + "static/media/efficient.23192eb9.png";